import { PageEvent } from '@angular/material/paginator';

export const pageSizeOptions: number[] = [5, 10, 25, 50, 100, 1000];
export const initialPage = {
  pageIndex: 0,
  pageSize: 100
} as PageEvent;
